export const selectCurrentKey = (state) => state.keyboard.currKey;
export const selectIsUserTypingStatus = (state) => state.keyboard.isUserTyping;
export const selectKeyCount = (state) => state.keyboard.keyCount;
export const selectOffsetCopyPaste = (state) => state.keyboard.offsetCopyPaste;
export const selectCtrlIsPressing = (state) => state.keyboard.keyCtrlIsPressing;
